{
  "title": "Finanzas",
  "description": "Gestione ingresos, pagos y datos bancarios",
  "tabs": {
    "overview": "Resumen",
    "transactions": "Transacciones",
    "payouts": "Pagos",
    "bankDetails": "Datos bancarios"
  },
  "overview": {
    "availableBalance": "Saldo disponible",
    "availableBalanceHint": "Saldo total de reservas, propinas y cargos",
    "withdrawable": "Retirable",
    "withdrawableHint": "Monto disponible para retirar (mín. GH₵20)",
    "requestPayout": "Solicitar pago",
    "requestingPayout": "Solicitando...",
    "payoutSuccess": "Pago solicitado correctamente",
    "payoutError": "Error al solicitar el pago",
    "recentActivity": "Actividad reciente",
    "recentActivityHint": "Últimas transacciones del negocio seleccionado",
    "emptyTransactionsTitle": "Sin transacciones recientes",
    "emptyTransactionsDescription": "Las transacciones aparecerán aquí cuando tenga actividad"
  },
  "income": {
    "documentTitle": "Gestión de ingresos",
    "pageTitle": "Gestión de ingresos",
    "pageDescription": "Gestione pagos y datos bancarios",
    "bankDetails": {
      "title": "Datos bancarios",
      "accountLabel": "Cuenta"
    },
    "withdraw": "Retirar",
    "requesting": "Solicitando...",
    "metrics": {
      "available": "Disponible",
      "withdrawable": "Retirable"
    },
    "payoutsTitle": "Pagos",
    "payouts": {
      "searchPlaceholder": "Buscar pagos..."
    },
    "toast": {
      "payoutRequested": "Pago solicitado correctamente",
      "payoutRequestFailed": "Error al solicitar el pago"
    }
  },
  "bankDetails": {
    "dialogTitle": "Información de la cuenta de pago",
    "fullName": {
      "label": "Nombre completo",
      "hint": "El nombre tal como aparece en su cuenta bancaria",
      "placeholder": "Juan Pérez"
    },
    "accountNumber": {
      "label": "Número de cuenta",
      "hint": "Su número de cuenta bancaria (solo dígitos)"
    },
    "bank": {
      "label": "Banco",
      "hint": "Seleccione su banco",
      "placeholder": "Seleccionar banco",
      "searchPlaceholder": "Buscar bancos...",
      "emptyMessage": "No se encontró ningún banco"
    },
    "submit": "Agregar cuenta",
    "adding": "Agregando...",
    "errors": {
      "fullNameRequired": "El nombre completo es obligatorio",
      "accountNumberRequired": "El número de cuenta es obligatorio",
      "bankRequired": "Seleccione un banco"
    },
    "toast": {
      "addInitiated": "Se ha iniciado la adición de la cuenta receptora del negocio"
    }
  },
  "transactions": {
    "pageTitle": "Transacciones",
    "pageDescription": "Haga seguimiento y revise la actividad reciente de transacciones",
    "searchPlaceholder": "Buscar cliente, ID de transacción...",
    "emptyTitle": "Sin transacciones",
    "emptyDescription": "Las transacciones aparecerán aquí cuando estén disponibles."
  },
  "payouts": {
    "searchPlaceholder": "Buscar pagos...",
    "emptyTitle": "Sin pagos",
    "emptyDescription": "El historial de pagos aparecerá aquí cuando realice un retiro."
  },
  "settings": {
    "payoutAccount": "Cuenta de pago",
    "payoutAccountHint": "Cuenta bancaria a la que se enviarán los retiros",
    "editBankDetails": "Editar datos bancarios",
    "accountNumber": "Número de cuenta",
    "noAccount": "Sin cuenta configurada",
    "addAccountHint": "Agregue su cuenta bancaria para recibir pagos de reservas completadas."
  },
  "columns": {
    "customer": "Cliente",
    "date": "Fecha",
    "type": "Tipo",
    "status": "Estado",
    "reference": "Referencia",
    "transactionId": "ID de transacción",
    "externalReference": "Referencia externa"
  },
  "transactionTypes": {
    "all": "Todos",
    "bookingFee": "Tarifa de reserva",
    "additionalCharge": "Cargo adicional",
    "tip": "Propina",
    "refund": "Reembolso",
    "subscriptionFee": "Tarifa de suscripción",
    "payout": "Pago",
    "platformFee": "Tarifa de plataforma",
    "adPayout": "Pago publicitario",
    "adRevenue": "Ingresos publicitarios"
  },
  "transactionStatuses": {
    "pending": "Pendiente",
    "pendingAuthorization": "Pendiente de autorización",
    "pendingAny": "Pendiente",
    "completed": "Completada",
    "success": "Exitosa",
    "failed": "Fallida",
    "cancelled": "Cancelada",
    "initiated": "Iniciada",
    "declined": "Rechazada"
  }
}
